var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('page',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("Pagina niet gevonden")]},proxy:true}])},[_c('block',{class:'no-flex',attrs:{"blockTitle":"Oeps!"}},[_c('p',[_vm._v("Ik heb overal gezocht, maar kan deze pagina niet vinden!")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }